import Header from "@/components/landing/Header";
import Services from "@/components/landing/Services";
import Footer from "@/components/landing/Footer";
import Seo from "@/components/Seo";

export default function Leistungen() {
  return (
    <>
      <Seo
        title="Leistungen: Gründung, Visa & Relocation in Florida"
        description="Unsere Leistungen für Deutsche & Schweizer in Florida: Unternehmensgründung (LLC & Corporation), Immigration & Visum, Relocation, Beratung nach der Auswanderung und fixfertige Business-Ideen."
        keywords="Unternehmensgründung Florida, LLC gründen Florida, Relocation Florida, Immigration Service Florida, Auswanderungsberatung auf Deutsch, Business-Ideen Florida, Firma in USA gründen"
      />
      <Header />
      <main className="pt-20" data-testid="leistungen-page">
        <Services />
      </main>
      <Footer />
    </>
  );
}
